import { useState, useEffect } from "react";
import DonutWidget from "./DonutWidget";
import styles from "./graph.module.css";
import { styled } from "@mui/material/styles";
import { Tooltip } from "@mui/material";
import { tooltipClasses } from "@mui/material/Tooltip";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";

const BGColor = [
  "#00BFFF",
  "#32CD32",
  "#FFC107",
  "#DC143C",
  "#FFDAB9",
  "#40E0D0",
  "#FFA07A",
  "#0027ED",
  "#F6FF00",
  "#FF69B4",
];

const Graph = ({ filterData, isListChange }) => {
  const BootstrapTooltip = styled(({ className, ...props }) => (<Tooltip {...props} arrow classes={{ popper: className }} />))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.black,
      fontSize: 13,
    },
  }));
  const { getAccessTokenSilently } = useAuth0();
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    async function getLeases() {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
      let params = {};

      if (filterData?.property !== "" && filterData?.property !== "all") {
        params = { ...params, property_id: filterData?.property };
      }

      if (filterData?.apartment !== "" && filterData?.apartment !== "all") {
        params = { ...params, apt_id: filterData?.apartment };
      }

      if (filterData?.type !== "" && filterData?.type !== "all") {
        params = { ...params, status: filterData?.type };
      }

      axios(process.env.REACT_APP_TENANT_API_URL + "v1/vehicle-chart-data", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: params,
      }).then((response) => {
        setChartData(response.data.data);
      }).catch((error) => { });
    }
    getLeases();
  }, [getAccessTokenSilently, isListChange]);

  return (chartData && (<>
    {chartData?.total > 0 && (<>
      <div className={`${styles.ChartMainSec}`}>
        <div className={`${styles.TotalIncomeSec}`}>
          <p className={`${styles.Amount}`}>{chartData?.total}</p>
          <p className={`${styles.Text}`}>Total Cars</p>
          <p className={`${styles.Text2}`}>{chartData?.tenant} Tenant</p>
          <p className={`${styles.Text2}`}>{chartData?.guest} Guest</p>
        </div>
        <div className={`${styles.ChartSec}`}>
          <DonutWidget chartData={chartData} />
        </div>
      </div>
      <div className={`${styles.ChartListCatMain}`}>
        {chartData?.properties?.map((i, index) => {
          const total = i?.total || 0;
          const tenant = i?.tenant || 0;
          const guest = i?.guest || 0;
          const tenantPercent = total ? (tenant / total) * 100 : 0;
          const guestPercent = total ? (guest / total) * 100 : 0;

          return (<div className={styles.ChartListCat} key={i}>
            <p>{i?.title} <span>{total.toLocaleString()}</span></p>
            <div className={styles.ChartProgressTrack}>
              <BootstrapTooltip title={<div className={styles.IncomeLineTooltip}>
                <p>Tenant Cars: {tenant.toLocaleString()}</p>
              </div>}>
                <div style={{ width: `${tenantPercent}%`, backgroundColor: BGColor[index], cursor: "pointer" }}></div>
              </BootstrapTooltip>
              <BootstrapTooltip title={<div className={styles.IncomeLineTooltip}>
                <p>Guest Cars: {guest.toLocaleString()}</p>
              </div>}>
                <div style={{ width: `${guestPercent}%`, backgroundColor: BGColor[index], cursor: "pointer", filter: "brightness(0.75)" }}></div>
              </BootstrapTooltip>
            </div>
          </div>);
        })}
      </div></>)}
    {chartData?.total === 0 && <div className={`${styles.NoDataMain}`}>
      <div className={`${styles.NoDataIMG}`}>
        <img src="/static/img/no-car.png" alt="No Data" />
      </div>
      <p className={`${styles.NoDataText}`}>Oops!</p>
      <p className={`${styles.NoDataTextSub}`}>Looks like the parking lot is empty</p>
    </div>}
  </>));
}

export default Graph;